"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = require("react");

var qs_1 = require("qs");

var omit_1 = tslib_1.__importDefault(require("lodash-es/omit"));

var modules_1 = require("../modules");

var utils_1 = require("../utils");

function useModalHistory(modalKey, isOpen, onClose) {
  var _react_1$useState = react_1.useState(window.location.pathname),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 1),
      pathname = _react_1$useState2[0];

  var pushModalQuery = react_1.useCallback(function () {
    var openModals = modules_1.openModalStack.getOpenModals();
    var state = {
      openModals: openModals
    };
    var currentQuery = utils_1.getParsedSearchParams();
    var query = openModals.length ? qs_1.stringify(Object.assign(Object.assign({}, currentQuery), state), utils_1.stringifyOption) : qs_1.stringify(omit_1.default(currentQuery, ['openModals']), utils_1.stringifyOption);
    window.history.pushState(state, '', "".concat(pathname).concat(query));
  }, [pathname]);
  var replaceModalQuery = react_1.useCallback(function () {
    var openModals = modules_1.openModalStack.getOpenModals();
    var state = {
      openModals: openModals
    };
    var currentQuery = utils_1.getParsedSearchParams();
    var query = openModals.length ? qs_1.stringify(Object.assign(Object.assign({}, currentQuery), state), utils_1.stringifyOption) : qs_1.stringify(omit_1.default(currentQuery, ['openModals']), utils_1.stringifyOption);
    window.history.replaceState(state, '', "".concat(pathname).concat(query));
  }, [pathname]);
  var clearModalQuery = react_1.useCallback(function (eventState) {
    var currentQuery = utils_1.getParsedSearchParams();
    var query = qs_1.stringify(omit_1.default(currentQuery, ['openModals']), utils_1.stringifyOption);
    window.history.replaceState(eventState, '', "".concat(pathname).concat(query));
  }, [pathname]);
  var pushModal = react_1.useCallback(function () {
    modules_1.openModalStack.pushModalKey(modalKey);
    pushModalQuery();
  }, [modalKey, pushModalQuery]);
  var popModal = react_1.useCallback(function () {
    var poppedModalKey = '';
    var openModals = modules_1.openModalStack.getOpenModals();

    if (openModals[openModals.length - 1] === modalKey) {
      poppedModalKey = modules_1.openModalStack.popModalKey();
      replaceModalQuery();
    }

    return poppedModalKey;
  }, [modalKey, replaceModalQuery]);
  var handlePopState = react_1.useCallback(function (event) {
    var _a, _b;

    if (!modalKey) {
      return;
    }
    /** 쿼리와 이벤트 state를 비교하여 앞으로 가기 동작으로 판단되는 경우 쿼리 보정 */


    var currentQuery = utils_1.getParsedSearchParams();
    var queryState = currentQuery.openModals ? utils_1.getStringListParam(currentQuery.openModals) : [];
    var eventState = (_b = (_a = event.state) === null || _a === void 0 ? void 0 : _a.openModals) !== null && _b !== void 0 ? _b : [];

    if (queryState.length > eventState.length) {
      clearModalQuery({
        openModals: eventState
      });
      return;
    }
    /** 이외의 경우는 뒤로 가기 동작이므로 pop 수행 */


    var poppedModalKey = popModal();

    if (poppedModalKey === modalKey) {
      onClose();
    }
  }, [modalKey, clearModalQuery, popModal, onClose]);
  react_1.useEffect(function () {
    if (!modalKey) {
      return;
    }

    if (isOpen) {
      pushModal();
    } else {
      popModal();
    }
  }, [modalKey, isOpen, pushModal, popModal]);
  react_1.useEffect(function () {
    window.addEventListener('popstate', handlePopState);
    return function () {
      // FIXME: 라우트 변경시에만 스택을 비우도록 해야 함
      // openModalStack.clearOpenModals();
      window.removeEventListener('popstate', handlePopState);
    };
  }, [handlePopState]);
}

exports.default = useModalHistory;